'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('bulletin-show', {
      url: '/bulletin/:id',
      template: '<bulletin-show></bulletin-show>',
        authenticate: true
    })
    .state('listing-show', {
      url: '/listing/:id',
      template: '<bulletin-show realtor="true"></bulletin-show>',
        authenticate: true
    })
    .state('public-bulletin-show', {
      url: '/public/bulletin/:id',
      template: '<bulletin-show public="true"></bulletin-show>'
    })
    .state('public-listing-show', {
      url: '/public/listing/:id',
      template: '<bulletin-show property="true"></bulletin-show>'
    });
}



// WEBPACK FOOTER //
// ./client/app/bulletin/show/bulletin-show.routes.js